/* NAUTIYA - PERF LOT 2 - 2026-08-02
   Desactive le flou des cartes d'avis ELOIGNEES de l'ecran.
   Securite : on ne retire jamais le flou par defaut. Si ce script ne
   tourne pas, l'apparence d'origine est conservee a l'identique. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  function init() {
    var cards = document.querySelectorAll('.rl-card');
    if (!cards.length) return;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        entries[i].target.classList.toggle('rl-out-view', !entries[i].isIntersecting);
      }
    }, { root: null, rootMargin: '300px', threshold: 0 });
    for (var i = 0; i < cards.length; i++) io.observe(cards[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();

/* NTY-FIX FLASH 2026-08-08 : desactive les cross-document view transitions de Horizon
   qui affichent un instantane de l'ancienne page a chaque navigation (le "flash").
   Injecte une regle @view-transition{navigation:none} qui l'emporte sur la regle
   navigation:auto du theme (la derniere regle @view-transition gagne).
   Pour annuler : supprimer ce bloc. */
(function () {
  try {
    var css = '@view-transition{navigation:none}';
    var s = document.createElement('style');
    s.id = 'nty-vt-off';
    s.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(s);
  } catch (e) {}
})();
